import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const RecruitmentFraudAwareness = () => {
  return (
    <div>
      <Helmet>
        <title>Recruitment Fraud Awareness | Idexcel</title>
        <meta
          content="recruitment fraud, recruitment fraud awareness, fraud and awareness, recruitment fraud warning, employee recruitment fraud prevention"
          name="keywords"
        />
        <meta
          content="Recruitment scams are increasingly being carried out online through false job advertisements, job websites, and unsolicited emails. Idexcel is committed to preventing any type of fraud related to jobs, fictitious job opportunities, and/or recruitment offerings."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
      <Container fluid className="recruitment-banner-container p-0">
        <section className="recruitment-banner-section"></section>
      </Container>
      </motion.div>


      <section>
        <Container className="my-5 px-xl-5">
          <section className="mb-5">
            <Row className="p-0 m-0 px-2 px-lg-4 pb-3" style={{textAlign: "justify"}}>
              {/* <h1 className="text-danger fontsize fw-semibold text-left mb-3">
                Recruitment Fraud Awareness
              </h1> */}
              <h2 className="text-center mb-4 section-title">
                Recruitment Fraud<span className="textgrad"> Awareness </span>
              </h2>
              <p className="py-1 px-3">
                It has recently come to our attention that Idexcel’s name is
                being used in recruitment scams. Recruitment scams are
                increasingly being carried out online through false job
                advertisements, job websites and through unsolicited emails,
                pretending to be from a legitimate company like Idexcel/ Idexcel
                Technologies. We are also aware that there have been several job
                advertisements placed on recruitment websites advertising
                fictitious jobs at Idexcel. The advertisements ask prospective
                applicants to contact an email address if they wish to apply for
                the job. Please be advised that these emails/advertisements are
                not connected with Idexcel/ Idexcel Technologies by any means.
              </p>
              <p className="py-1 px-3 my-2">
                Kindly note all legitimate open positions with Idexcel can be
                found advertised under the careers section of our website.
                Idexcel would always conduct a personal interview with you prior
                to any employment offers being extended. If you did not go
                through this process, please be on alert for fraudulent
                activity. Also, Idexcel never requests payments of any kind in
                order for applicants to secure a job. If at all you are asked to{" "}
                <b className="fw-semibold">
                  remit any kind of payment (or) to undergo any form of training
                  to secure an employment opportunity
                </b>
                , it should be certainly established that it is not from Idexcel
                and the individual/organization is not providing a genuine
                offer. Furthermore, if you receive any communication from an
                email address that does not end with the domain name{" "}
                <b className="fw-semibold">"idexcel.com"</b>, you should
                disregard the email and alert our{" "}
                <b className="fw-semibold">
                  HR Service Support via the email id:{" "}
                  <a
                    href="mailto:blrhr@idexcel.com"
                    className="text-danger textDecoration"
                  >
                    blrhr@idexcel.com
                  </a>
                </b>{" "}
                immediately so that appropriate action can be taken. Any emails
                using a different domain are unauthentic and not from Idexcel.
              </p>
              <p className="py-1 px-3 my-2">
                Fraudulent emails will often be sent either from free email
                providers (viz. Outlook, Gmail etc.) or use a domain name that
                is similar to Idexcel, that these scamsters pretend to
                represent.{" "}
                <b className="fw-semibold">
                  Some examples of email domains used in frauds
                </b>
                : @gmail.com; @idexcel-careers.com; idexcelit.com; @outlook.com;
                @hotmail.com; @yahoo.com etc. If possible, please send us the
                scam email as an attachment to your email, rather than simply
                forwarding it to us, in order to assist our investigations.
                Idexcel is taking this matter very seriously. By publishing this
                information and investigating the reports that we receive, we
                aim to prevent scammers from carrying out this activity and to
                protect individuals from becoming a victim of these scams.
                Thanks in advance for your kind understanding.
              </p>
            </Row>
          </section>
        </Container>
      </section>
    </div>
  );
};

export default RecruitmentFraudAwareness;
